(() => {
  const storageKey = 'tbk_because_family_code';
  const rootSelector = '[data-tbk-because-family]';
  const inputSelector = '[data-because-family-input]';
  const messageSelector = '[data-because-family-message]';
  const applySelector = '[data-because-family-apply]';

  const clean = value => String(value || '').trim();
  const getStored = () => {
    try { return clean(window.localStorage.getItem(storageKey)); } catch { return ''; }
  };
  const setStored = value => {
    try {
      if (value) window.localStorage.setItem(storageKey, value);
      else window.localStorage.removeItem(storageKey);
    } catch {}
  };
  const getCode = () => {
    const focused = document.activeElement && document.activeElement.matches && document.activeElement.matches(inputSelector)
      ? clean(document.activeElement.value)
      : '';
    return focused || clean(document.querySelector(inputSelector)?.value) || getStored();
  };
  const setMessage = (root, text, tone = 'default') => {
    const msg = root && root.querySelector(messageSelector);
    if (!msg) return;
    msg.textContent = text;
    msg.dataset.tone = tone;
  };
  const syncInputs = value => {
    document.querySelectorAll(inputSelector).forEach(input => {
      if (document.activeElement !== input) input.value = value;
    });
    document.documentElement.classList.toggle('tbk-because-family-has-code', Boolean(value));
  };
  const saveCode = () => {
    const code = getCode();
    setStored(code);
    syncInputs(code);
    document.querySelectorAll(rootSelector).forEach(root => {
      if (code) setMessage(root, 'Family code ready. Checkout will apply it automatically.', 'ready');
      else setMessage(root, 'Enter your one-time TBK family code before checkout.', 'default');
    });
    return code;
  };
  const checkoutWithCode = code => {
    const destination = code
      ? '/discount/' + encodeURIComponent(code) + '?redirect=/checkout'
      : '/checkout';
    window.location.assign(destination);
  };
  const wire = () => {
    const stored = getStored();
    if (stored) syncInputs(stored);
    document.querySelectorAll(rootSelector).forEach(root => {
      if (root.dataset.becauseFamilyWired === 'true') return;
      root.dataset.becauseFamilyWired = 'true';
      const input = root.querySelector(inputSelector);
      const apply = root.querySelector(applySelector);
      if (input) {
        input.addEventListener('input', () => {
          setStored(clean(input.value));
          syncInputs(clean(input.value));
        });
        input.addEventListener('keydown', event => {
          if (event.key === 'Enter') {
            event.preventDefault();
            saveCode();
          }
        });
      }
      if (apply) {
        apply.addEventListener('click', event => {
          event.preventDefault();
          const code = saveCode();
          setMessage(root, code ? 'Family code saved for checkout.' : 'Add a code first, then hit Apply.', code ? 'ready' : 'error');
        });
      }
      if (stored) setMessage(root, 'Family code ready. Checkout will apply it automatically.', 'ready');
    });
  };

  const shouldHandleCheckout = target => {
    if (!target) return false;
    if (target.matches && target.matches('button[name="checkout"], input[name="checkout"], .cart__checkout-button')) return true;
    const closest = target.closest && target.closest('button[name="checkout"], input[name="checkout"], .cart__checkout-button, a[href*="/checkout"]');
    return Boolean(closest);
  };

  document.addEventListener('click', event => {
    const target = event.target && event.target.closest ? event.target.closest('button, input, a') : null;
    if (!shouldHandleCheckout(target)) return;
    const code = saveCode();
    if (!code) return;
    event.preventDefault();
    event.stopPropagation();
    checkoutWithCode(code);
  }, true);

  document.addEventListener('submit', event => {
    const submitter = event.submitter;
    const form = event.target;
    const isCartCheckout = (submitter && shouldHandleCheckout(submitter))
      || (form && form.matches && form.matches('form[action*="/cart"]') && document.activeElement && shouldHandleCheckout(document.activeElement));
    if (!isCartCheckout) return;
    const code = saveCode();
    if (!code) return;
    event.preventDefault();
    checkoutWithCode(code);
  }, true);

  const style = document.createElement('style');
  style.textContent = `
    .tbk-because-family {
      display: grid;
      grid-template-columns: 1fr auto;
      gap: 10px;
      align-items: end;
      margin: 0 0 16px;
      padding: 16px;
      border: 1px solid rgba(16,16,16,.16);
      background: #101010;
      color: #fff;
    }
    .tbk-because-family__head {
      grid-column: 1 / -1;
      display: grid;
      gap: 3px;
    }
    .tbk-because-family__eyebrow {
      color: #d5b46a;
      font-size: 1rem;
      font-weight: 900;
      letter-spacing: .14em;
      line-height: 1.1;
      text-transform: uppercase;
    }
    .tbk-because-family strong {
      font-size: clamp(2rem, 2.2vw, 2.7rem);
      line-height: 1;
      letter-spacing: 0;
    }
    .tbk-because-family__label {
      min-width: 0;
    }
    .tbk-because-family__input {
      width: 100%;
      min-height: 46px;
      padding: 0 14px;
      border: 1px solid rgba(255,255,255,.32);
      border-radius: 0;
      background: #fff;
      color: #101010;
      font: inherit;
      letter-spacing: .04em;
      text-transform: uppercase;
    }
    .tbk-because-family__input:focus {
      outline: 2px solid #d5b46a;
      outline-offset: 2px;
    }
    .tbk-because-family__apply {
      min-height: 46px;
      padding-inline: 20px;
      border-color: #fff;
      background: #fff;
      color: #101010;
      white-space: nowrap;
    }
    .tbk-because-family__message {
      grid-column: 1 / -1;
      margin: 0;
      color: rgba(255,255,255,.72);
      font-size: 1.18rem;
      line-height: 1.35;
    }
    .tbk-because-family__message[data-tone="ready"] {
      color: #d5b46a;
    }
    .tbk-because-family__message[data-tone="error"] {
      color: #ffb4a8;
    }
    .tbk-because-family-has-code .cart__dynamic-checkout-buttons,
    .tbk-because-family-has-code .additional-checkout-buttons {
      display: none !important;
    }
    #CartDrawer .tbk-because-family {
      margin: 0 0 12px;
      padding: 14px;
    }
    #CartDrawer .tbk-because-family strong {
      font-size: 2rem;
    }
    @media screen and (max-width: 749px) {
      .tbk-because-family {
        grid-template-columns: 1fr;
      }
      .tbk-because-family__apply {
        width: 100%;
      }
    }
  `;
  if (!document.getElementById('tbk-because-family-style')) {
    style.id = 'tbk-because-family-style';
    document.head.appendChild(style);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', wire, { once: true });
  } else {
    wire();
  }
  window.addEventListener('load', wire, { once: true });
  document.addEventListener('cart:updated', wire);
  document.addEventListener('shopify:section:load', wire);
  setInterval(wire, 1500);
})();